import { CASES } from "./constants";

export const updatePMXDeliveries = (payload) => {
  return { type: CASES.UPDATE_PMX_DELIVERIES, payload };
};

export const updatePMXDeliveriesSearchForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_PMX_DELIVERIES_SEARCH_FORM,
    payload: { key, data },
  };
};

export const clearPMXDeliveries = () => {
  return { type: CASES.CLEAR_PMX_DELIVERIES, payload: {} };
};
